<template>
  <div class="page">
    <div class="banner">
      <img class="banner" src="@/assets/img/news/banner.png" />
    </div>
    <div class="content">
      <div class="header">
        <div class="info">
          <div class="title">
            {{ detail.title }}
          </div>
          <div class="desc">
            <span>{{ detail.publishTime }}</span>
            <!-- <span>新闻来源：公共关系办公室 江西中科智慧水研究公司</span> -->
          </div>
        </div>
        <a class="btn-1" @click="backToList">
          <div>《</div>
          <div>返回列表</div>
        </a>
      </div>
      <div class="content" v-html="detail.content"></div>
    </div>
  </div>
</template>

<script>
// import { getDetail } from "../config/newsDataList";
import { getNewsDetail } from "../api/newsApi";
export default {
  name: "Detail",
  data() {
    return {
      detail: {}
    };
  },
  created() {
    getNewsDetail(this.$route.params.id).then(res => {
      const data = res.data;
      this.detail = data;
    });
  },
  methods: {
    backToList() {
      this.$router.push("/news");
    }
  }
};
</script>

<style scoped>
@import "../assets/css/main.css";
.content {
  min-height: 200px;
}
.header {
  padding-bottom: 31px;
  border-bottom: 1px solid rgba(231, 231, 231, 1);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Source Han Sans CN;
}
.header .info .title {
  width: 1150px;
  font-size: 36px;
  font-weight: bold;
  color: rgba(37, 37, 37, 1);
  line-height: 48px;
}
.header .info .desc {
  font-weight: 400;
  color: rgba(115, 115, 115, 1);
  line-height: 60px;
  font-size: 16px;
}
.header .info .desc span {
  margin-right: 30px;
}
</style>
